"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _has = _interopRequireDefault(require("lodash/has"));
var _propTypes = require("prop-types");
var _downshift = _interopRequireDefault(require("downshift"));
var _item = _interopRequireDefault(require("./item"));
var _utils = require("./utils");
var _styles = require("./styles");
const defaultProps = {
  ..._downshift.default.defaultProps,
  items: [],
  placement: 'below',
  className: 'option-list'
};
const propTypes = {
  ..._downshift.default.propTypes,
  /**
   * The list of items that can be selected from: either a list of strings or a list of objects.
   */
  items: (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([_propTypes.object, _propTypes.string])),
  /**
   * Placement for where the option list should appear.
   */
  placement: (0, _propTypes.oneOf)(['below', 'above']),
  /**
   * Options list class name
   */
  className: _propTypes.string
};
const OptionList = _ref => {
  let {
    items,
    highlightedIndex,
    inputValue,
    getItemProps,
    placement,
    className,
    categories
  } = _ref;
  const options = (0, _utils.groupItems)(categories, items);
  return /*#__PURE__*/_react.default.createElement(_styles.StyledPaper, {
    elevation: placement === 'above' ? 1 : 4,
    "data-placement": placement,
    className: className
  }, (0, _map.default)(options).call(options, (item, index) => {
    const isHeading = (0, _has.default)(item, 'category');
    const key = item.content_type && item.value ? `${item.content_type} - ${item.value}` : item.value ?? item.category;
    return /*#__PURE__*/_react.default.createElement(_styles.Option, (0, _extends2.default)({}, getItemProps({
      item,
      disabled: isHeading
    }), {
      index: index,
      highlightedIndex: highlightedIndex,
      isHeading: isHeading,
      key: key
    }), isHeading ? /*#__PURE__*/_react.default.createElement(_styles.Heading, null, item.display) : /*#__PURE__*/_react.default.createElement(_item.default, {
      label: item.label,
      inputValue: inputValue
    }));
  }));
};
OptionList.propTypes = propTypes;
OptionList.defaultProps = defaultProps;
var _default = exports.default = OptionList;
OptionList.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "OptionList",
  "props": {
    "items": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "The list of items that can be selected from: either a list of strings or a list of objects.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "object"
          }, {
            "name": "string"
          }]
        }
      },
      "required": false
    },
    "placement": {
      "defaultValue": {
        "value": "'below'",
        "computed": false
      },
      "description": "Placement for where the option list should appear.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'below'",
          "computed": false
        }, {
          "value": "'above'",
          "computed": false
        }]
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "'option-list'",
        "computed": false
      },
      "description": "Options list class name",
      "type": {
        "name": "string"
      },
      "required": false
    }
  },
  "composes": ["downshift"]
};